import { mount } from "@vue/test-utils";
import DateField from "@/components/core/DateField";

describe("DateField test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(DateField, {
      props: {
        value: "11/02/2023",
        required: false,
        subhint: "Fecha"
      }
    });
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });
  it("Render del component DateField", () => {
    expect(wrapper).toBeDefined();
  });
});
